import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { getCanDrag } from '../../util';
export function withFileDragListener(Component) {
  var DragAndDrop = /*#__PURE__*/function (_React$Component) {
    function DragAndDrop() {
      var _this;
      _classCallCheck(this, DragAndDrop);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, DragAndDrop, [].concat(args));
      _defineProperty(_this, "dragTimeout", void 0);
      _defineProperty(_this, "state", {
        isDragging: false
      });
      _defineProperty(_this, "finishDragging", function () {
        _this.setState({
          isDragging: false
        });
      });
      _defineProperty(_this, "onDragEnter", function (e) {
        if (!_this.isDraggingFiles(e.dataTransfer)) {
          return;
        }
        if (!_this.state.isDragging) {
          _this.setState({
            isDragging: true
          });
        }
        e.stopPropagation();
        e.preventDefault();
      });
      _defineProperty(_this, "onDragOver", function (e) {
        clearTimeout(_this.dragTimeout);
        _this.dragTimeout = setTimeout(function () {
          return _this.setState({
            isDragging: false
          });
        }, 500);
        e.stopPropagation();
        e.preventDefault();
      });
      return _this;
    }
    _inherits(DragAndDrop, _React$Component);
    return _createClass(DragAndDrop, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(Component, _extends({}, this.props, {
          isDraggingFiles: this.state.isDragging,
          onFilesDropped: this.finishDragging
        }));
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if (getCanDrag()) {
          document.body.addEventListener('dragenter', this.onDragEnter);
          document.body.addEventListener('dragover', this.onDragOver);
        }
      }
    }, {
      key: "isDraggingFiles",
      value: function isDraggingFiles(dataTransfer) {
        if (dataTransfer.items && dataTransfer.items.length > 0) {
          return Array.from(dataTransfer.items).some(function (item) {
            return item.kind.toLowerCase() === 'file' || item.type === 'text/uri-list';
          });
        }
        return Array.from(dataTransfer.types).some(function (type) {
          return type.toLowerCase() === 'files';
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.body.removeEventListener('dragenter', this.onDragEnter);
        document.body.removeEventListener('dragover', this.onDragOver);
      }
    }]);
  }(React.Component);
  return DragAndDrop;
}